if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      
      // Enhanced cart functionality - preserve original button text
      this.originalButtonText = this.submitButton.textContent.trim();
      this.preventCartRedirect = this.dataset.preventCartRedirect !== 'false'; // Default to true unless explicitly set to false
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              // Enhanced cart functionality - prevent redirect if enabled
              if (this.preventCartRedirect) {
                // Show success feedback instead of redirecting
                this.showAddedToCartFeedback();
              } else {
                // Original behavior - redirect to cart page
                window.location = window.routes.cart_url;
              }
              return;
            }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          
          // Enhanced cart functionality - show success feedback
          this.showAddedToCartFeedback();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          
          // Enhanced cart functionality - reset button text after delay if success
          if (!this.error) {
            setTimeout(() => {
              this.resetButtonText();
            }, 2000); // Reset after 2 seconds
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    // Enhanced cart functionality - new methods for button feedback
    showAddedToCartFeedback() {
      const buttonTextElement = this.submitButton.querySelector('span') || this.submitButton;
      buttonTextElement.textContent = 'Added to cart';
      this.submitButton.classList.add('cart-success');
      
      // Update cart icon bubble count
      this.updateCartIconCount();
    }

    resetButtonText() {
      const buttonTextElement = this.submitButton.querySelector('span') || this.submitButton;
      buttonTextElement.textContent = this.originalButtonText;
      this.submitButton.classList.remove('cart-success');
    }

    updateCartIconCount() {
      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (!cartIconBubble) return;

      // Get the quantity added from the form
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const addedQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      // Find or create the cart count bubble
      let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
      if (!cartCountBubble) {
        // Create the cart count bubble if it doesn't exist (empty cart)
        cartCountBubble = document.createElement('div');
        cartCountBubble.className = 'cart-count-bubble';
        cartIconBubble.appendChild(cartCountBubble);
      }

      // Find or create the count span
      let countSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
      if (!countSpan) {
        countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        cartCountBubble.appendChild(countSpan);
      }

      // Update the count
      const currentCount = parseInt(countSpan.textContent) || 0;
      const newCount = currentCount + addedQuantity;
      countSpan.textContent = newCount < 100 ? newCount : '99+';

      // Update or create the visually hidden span for screen readers
      let visuallyHiddenSpan = cartCountBubble.querySelector('.visually-hidden');
      if (!visuallyHiddenSpan) {
        visuallyHiddenSpan = document.createElement('span');
        visuallyHiddenSpan.className = 'visually-hidden';
        cartCountBubble.appendChild(visuallyHiddenSpan);
      }
      visuallyHiddenSpan.textContent = `Cart has ${newCount} item${newCount !== 1 ? 's' : ''}`;

      // Add a subtle animation to draw attention
      cartCountBubble.style.transform = 'scale(1.2)';
      setTimeout(() => {
        cartCountBubble.style.transform = 'scale(1)';
      }, 200);
    }
  });
}

$(document).ajaxComplete(function() {
  CartJS.updateCart();
});
